import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// material
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import LegislationCard from './LegislationCard';

import { getLabel, getLegislations } from '../pages/utils_v2/kumuHelper'
// constants
import { QuestionPhase } from '../constants';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

// ActivityPicker.propTypes = {
//     activites: PropTypes.array.isRequired,
//     category: PropTypes.string.isRequired,
//     // options: PropTypes.array.isRequired,
//     // handleChange: PropTypes.func.isRequired
// };

export default function LegislationPicker({legislations, setCurrentLegislation, elements, connections, setQuestionPhase, results}) {

  const { t, i18n } = useTranslation('translation')
  const handleResults = (e) => {
    setQuestionPhase(QuestionPhase.RESULTS)
  }

  const handleBack = (e) => {
    setQuestionPhase(QuestionPhase.ACTIVITYSELECT)
  }

  return (
    <Box mt={4}>
        <p>{t('Answer some questions to learn more about the pieces of legislation below and how they might apply to your project. You will receive a green checkmark with the word "Completed" next to it in the top right corner of the legislation information box indicating that you have clicked through that section.')}</p>
        <Box>
            <Grid container direction='row'>
                {[...legislations]
                  .sort((a, b) =>
                    getLabel(a, i18n.language).localeCompare(
                      getLabel(b, i18n.language),
                      i18n.language
                    )
                  )
                  .map(legislation => {
                    return (
                        <Grid item md={12} xs={12} sm={12} mt={4}>
                            <LegislationCard legislation={legislation} setQuestionPhase={setQuestionPhase} setCurrentLegislation={setCurrentLegislation} results={results}/>
                        </Grid>    
                    )
                })}
            </Grid>
        </Box>
        
        <br />
        <div className="left" style={{ display: 'flex', gap: '8px' }}>
            <button
              className="btn btn-primary wide-button"
              onClick={(e) => handleBack(e)}
            >{t('Back')}</button>

            <button
              className="btn btn-primary wide-button"
              onClick={(e) => handleResults(e)}
            >{t('Show Results')}</button>
        </div>
    </Box>
  );
}